import styled, { css } from 'styled-components';

export const Container = styled.div``;
export const ContainerText = styled.div`
  text-align: center;
  padding: 60px 0 30px 0;

  p {
    font-family: 'Inter', sans-serif;
    font-size: 32px;
  }

  @media (max-width: 425px) {
    p {
      font-size: 19px;
    }
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  overflow: hidden;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    overflow-x: auto;

    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const AlignButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;
export const ImageContainerVersions = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
  overflow-x: auto;

  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    overflow-x: auto;
    scroll-behavior: smooth;
    padding: 0;
  }
`;

export const ContainetSection = styled.div`
  display: flex;

  @media (max-width: 320px) {
    width: 310px;
  }

  @media (max-width: 375px) {
    width: 350px;
  }

  ${({ bgColor }) =>
    css`
      background-color: ${bgColor};
    `}
`;

export const LogoContainer = styled.div`
  width: 100%;
  max-width: 60%; /* Mantém seu limite de 60% */
  margin-bottom: 20px;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
    max-height: 80px; /* Evita que fique muito alto */
  }

  @media (max-width: 768px) {
    max-width: 70%;

    img {
      max-height: 60px;
    }
  }

  @media (max-width: 500px) {
    max-width: 80%;

    img {
      max-height: 50px;
    }
  }
`;

export const ContainerInfos = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 375px;
  padding: 30px;
  p,
  strong,
  h1 {
    color: #fff;
    font-family: 'Inter', sans-serif;
    line-height: 25px;
  }

  strong {
    font-size: 28px;
  }

  @media (max-width: 768px) {
    width: 326px;

    p {
      font-size: 13px;
      line-height: 20px;
    }
  }

  ${({ bgColor }) =>
    css`
      background-color: ${bgColor};
    `}
`;

export const AlignButtonDetail = styled.div`
  margin-left: auto;
  height: 50px;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

export const ContainerImg = styled.div`
  position: relative;
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  img {
    object-fit: cover;
  }

  @media (max-width: 768px) {
    img {
      max-width: 130%;
    }
  }
`;

export const Button = styled.button`
  width: 170px;
  height: 50px;
  border-radius: 9999px;
  border: none;
  background-color: #fff;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 130px;
    height: 40px;
    font-size: 14px;
  }

  ${({ txtColor }) =>
    css`
      color: ${txtColor};
    `}
`;
